export default "__VITE_ASSET__213ba78a__"